/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { CopyLatLonCommand } from './copy-lat-lon.command';
import { Actions } from '@ngxs/store';

export function copyLatLonFactory() {
    const command = new CopyLatLonCommand();
    command.setDependencies({
        interactions: inject(MapInteractionsService),
        actions$: inject(Actions),
    });
    return command;
}
